import React from 'react';
import Searches from './Search';
import { useState, useEffect, useContext } from "react";
import { MyContext } from "../../context";
import ClientRightInstallation from "./ClientAllInstallation";
import ClientBatteryInfo from "./ClientBatteryInfo";
import ManualScroll from './ManualScroll'
import ClientAllPacks from './ClientAllPacks'
import ClientAllBatteries from "./ClientAllBatteries"
import ClientAllCells from "./ClientAllCells"
import ClientGraph from "./ClientGraph"
import ClientBankInfo from "./ClientBankInfo"
import ClientPackInfo from "./ClientPackInfo"
import MyTicketCard from "./TicketMyTicketCard"
import Ticket from './Ticket';
import TicketAllClosed from "./TicketAllClosed"

function MyTicket(){

  const { InstallationLinkSelection, updateInstallationLinkSelection, MyTicket, updateMyTicket} = useContext(MyContext);

  const [BankInfo, setBankInfo] = useState({
    id1: {
      name: "Central Office Pack",
      id: "2352kjjfa39919485hf248923g892h3",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    },  id2: {
      name: "Deco Park",
      id: "2352kjjfa39919485hf248923g892h6",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    }
  });

  const [PacksInfo, setPacksInfo] = useState({
    pack1: {
      name: "Pack 1",
      id: "2352kjjfa399194855",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    },  pack2: {
      name: "Pack 2",
      id: "2352kjjfa399194856",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    }
  });

  const [BatteryInfo, setBatteryInfo] = useState({
    battery1: {
      name: "Battery 1",
      id: "2352kjjfa392352kjjfa39",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    },  battery2: {
      name: "Battery 2",
      id: "2352kjjfa402352kjjfa40",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    },  battery3: {
      name: "Battery 3",
      id: "2352kjjfa402352kjjfa41",
      type: "Z-Range",
      location: "Randburg",
      date: "14 June 2013",
    },  battery4: {
      name: "Battery 4",
      id: "2352kjjfa402352kjjfa42",
      type: "Z-Range",
      location: "Randburg",
      date: "15 June 2013",
    }
    
  });

  const [CellInfo, setCellInfo] = useState({
    CellInfo1: {
      name: "Cell 1",
      id: "2352kjjfa392352kjjfa43",
      voltage: "35",
      location: "Randburg",
      date: "14 June 2013",
    },  CellInfo2: {
      name: "Cell 2",
      id: "2352kjjfa402352kjjfa44",
      voltage: "36",
      location: "Randburg",
      date: "14 June 2013",
    },  CellInfo3: {
      name: "Cell 3",
      id: "2352kjjfa402352kjjfa45",
      voltage: "34",
      location: "Randburg",
      date: "14 June 2013",
    },  CellInfo4: {
      name: "Cell 4",
      id: "2352kjjfa402352kjjfa46",
      voltage: "35",
      location: "Randburg",
      date: "15 June 2013",
    }
    
  });
 

  let RightLink = () => {
    switch (MyTicket) {
      case "":
        return (
          <>
          
            <div class="col-sm-12">
           <MyTicketCard />
           </div>

          </>
        );
        break;

      case "Ticket":
        return (
          <>
          <Ticket />
          </>
        );
        break;

      case "AllClosed":
        return (
          <>
           <div class="col-sm-10">
            <TicketAllClosed />
            </div>
          </>
        );
        break;

      

    }
  };

  //const bankInfoArray = Object.entries(BankInfo).map(([id, item]) => ({ id, ...item }));
 // const PacksInfoArray = Object.entries(PacksInfo).map(([id, item]) => ({ id, ...item }));

    return (
       
        <>
          <div className='OverviewContainer'  style={{paddingLeft: "240px", paddingRight: "80px"}}>
            <p className='dashboard_title'>Tickets</p>

           <Searches />

           <div class="row">
            
            
            {RightLink()}

           

       {/*     
<div class="col-sm-3">
    <div className="card" style={{width: "18rem;"}}>
        <div className="card-body">
            

        <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="iconCard"> 
                        
                        <span class="material-symbols-rounded">offline_bolt</span>

                        </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Installation</h6>
                        </div>
                    </div>
                    <div class="badge" style={{display: "flex"}}> 
                    <div class="material-symbols-rounded plantLink" >Settings</div>
                    
                  
                    </div>
                </div>
   
<div className='d-flex'>
    
   <div className='smallInfo' style={{display: "flex",width:"100%"}}>
    
  
    
    </div>

   
  </div>
    <hr />
   
    <p><strong>Add Bank: </strong></p>
   
   <div className='d-flex'>
       
      <div className='smallInfo' style={{display: "flex", width:"100%"}}>
       
      <span style={{marginTop: "-3px", paddingLeft:"5px", width:"100%"}}>
   
      <div>
    <span className='BIcon3' style={{marginTop:"0px", marginBottom:"20pxs"}} onClick={() => updateInstallationLinkSelection("Bank")}><span class="material-symbols-rounded size" style={{paddingTop:"6px", marginRight:"5px"}}>battery_5_bar</span> <span style={{paddingTop:"9px"}}>Add Battery Bank</span></span>
    </div>
     
        </span>
   
        </div>
    </div>

   

     {InstallationLinkSelection === "Installation" ? (
              ""
              ) : (
                <span>
 <hr />
<p><strong>All Installations: </strong></p>
   
   <div className='d-flex'>
       
      <div className='smallInfo' style={{display: "flex", width:"100%"}}>
       
     <span style={{marginTop: "-3px", paddingLeft:"5px", width:"100%"}}>
   
      <div>
    <span className='BIcon3' style={{marginTop:"0px", marginBottom:"20pxs"}} onClick={() => updateInstallationLinkSelection("Installation")}><span class="material-symbols-rounded size" style={{paddingTop:"6px", marginRight:"5px"}}>offline_bolt</span> <span style={{paddingTop:"9px"}}>All Installed Banks</span></span>
    </div>
     
        </span>
       </div>
     </div>



                </span>

                
              )}

{InstallationLinkSelection === "AllCells" ? (
              <span>
              <hr />
             <p><strong>Cells Max/Min: </strong></p>
                
                <div className='d-flex'>
                    
                   <div className='smallInfo' style={{display: "flex", width:"100%"}}>
                    
                   <span style={{marginTop: "-3px", paddingLeft:"5px", width:"100%"}}>
                
                   <div>
                


                  <div style={{display:"flex"}}>
                     <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Min Volt: </strong></span>

                     <p className='Font-primary currentCharging'>23V</p> 
                    </div>

                    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Min Position: </strong></span>

                     <p className='Font-primary currentCharging'>Cell 3</p> 
                    </div>
                  </div>



                  <div style={{display:"flex"}}>
                    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Max Volt: </strong></span>

                    <p className='Font-primary currentCharging'>45V</p> 
 
                    </div>

                    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Max Position: </strong></span>

                     <p className='Font-primary currentCharging'>Cell 1</p> 
                    </div>
                  </div>


                 </div>
                  
                     </span>
                    </div>
                  </div>
             
             
             
                             </span>

                             

                             
              ) : (
                ""

                
              )}



              
{InstallationLinkSelection === "AllCells" ? (
              <span>
              <hr />
             <p><strong>Voltage Differents: </strong></p>
                
                <div className='d-flex'>
                    
                   <div className='smallInfo' style={{display: "flex", width:"100%"}}>
                    
                   <span style={{marginTop: "-3px", paddingLeft:"5px", width:"100%"}}>
                
                   <div>
                


                   <p style={{fontSize:"30px", color:"#212529"}}><span class="material-symbols-rounded">battery_5_bar</span>
    <strong>10V</strong>
    </p>




                 </div>
                  
                     </span>
                    </div>
                  </div>
             
             
             
                             </span>

                             

                             
              ) : (
                ""

                
              )}
   
 
   
   


        </div>
    </div>




</div>


 */}
           
          </div>
          
          </div>
        </>
    )
}

export default MyTicket;